<template>
  <div class="mpm_upload_img">
    <a-spin :spinning="spinning">
      <div class="table-cell_upload upload_card" :class="{ 'upload-card-hover': displayUrl }">
        <input type="file" accept="video/mp4" ref="fileDom" style="display: none" @change="getFile" />
        <span class="table-cell_upload_1" v-if="!displayUrl" @click="uploadFile">
          <div class="upload-placeholder">
            <a-icon :type="uploading ? '' : 'plus'" />
            <div class="ant-upload-text">上传</div>
            <div class="ant-upload-text">30s内视频.mp4</div>
            <!-- <div class="ant-upload-hint">{{ maxSize }}MB以内</div> -->
          </div>
        </span>
        <div class="video_block" v-if="displayUrl">
          <video
            :src="displayUrl"
            initial-time="0"
            loop="false"
            muted="true"
            direction="0"
            class="video-preview"
          ></video>
          <div class="upload-list-item-actions">
            <a-icon type="eye" class="action-icon" @click.stop="handlePreview" />
            <a-icon type="delete" class="action-icon" @click.stop="handleRemove" />
          </div>
        </div>
      </div>

      <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel" :width="720" centered>
        <div class="modal_video">
          <video :src="displayUrl" controls="controls" autoplay class="video-player"></video>
        </div>
      </a-modal>
    </a-spin>
  </div>
</template>
<script>
  import { putObject } from '@/config/alioss'
  import { UPLOAD_CDN_HOST } from '@/config/env'

  export default {
    model: {
      prop: 'value',
    },
    props: {
      url: String,
      maxSize: {
        type: Number,
        default: 1000, // 默认上传大小限制为1000MB
      },
      showProgress: {
        type: Boolean,
        default: true,
      },
    },
    created() {
      this.initDisplayUrl()
    },
    data() {
      return {
        previewVisible: false,
        spinning: false,
        uploading: false,
        displayUrl: '',
        baseUrl: UPLOAD_CDN_HOST[process.env.VUE_APP_SERVER_ENV],
        videoCoverUrl: '', //封面图
      }
    },
    watch: {
      url(newValue) {
        if (newValue) {
          // 先判断是否包含http
          if (newValue.includes('http')) {
            this.displayUrl = newValue
          } else {
            this.displayUrl = this.baseUrl + newValue
          }
        }
      },
    },
    methods: {
      // 初始化显示的URL
      initDisplayUrl() {
        if (this.url) {
          this.displayUrl = this.baseUrl + this.url
        } else {
          this.displayUrl = ''
        }
        console.log('this.displayUrl', this.displayUrl)
      },

      formatFileSize(size) {
        if (!size) return '0 B'

        const units = ['B', 'KB', 'MB', 'GB']
        let i = 0
        let formattedSize = size

        while (formattedSize >= 1024 && i < units.length - 1) {
          formattedSize /= 1024
          i++
        }

        return `${formattedSize.toFixed(2)} ${units[i]}`
      },
      /**
       * 上传文件事件
       **/
      uploadFile() {
        this.$refs.fileDom.dispatchEvent(new MouseEvent('click'))
      },
      /**
       * 上传文件
       **/
      async getFile(event) {
        const file = this.$refs.fileDom.files[0]
        if (!file) {
          this.$refs.fileDom.value = ''
          return
        }

        try {
          const isValid = await this.beforeUpload(file)
          if (!isValid) {
            this.$refs.fileDom.value = ''
            return
          }

          this.handleUpload(file)
        } catch (error) {
          console.error('文件校验失败:', error)
          this.$message.error('文件校验失败')
          this.$refs.fileDom.value = ''
        }
      },
      /**
       * 预览
       **/
      handlePreview() {
        this.previewVisible = true
      },
      /**
       * 关闭预览事件
       **/
      handleCancel() {
        this.previewVisible = false
      },

      /**
       * 上传前校验
       **/
      beforeUpload(file) {
        // 检查文件格式
        const isMP4 = file.type === 'video/mp4'
        if (!isMP4) {
          this.$message.error('只能上传MP4格式的视频文件')
          return false
        }

        const isLtSize = file.size / 1024 / 1024 <= this.maxSize
        if (!isLtSize) {
          this.$message.error(`文件必须小于 ${this.maxSize}MB!`)
          return false
        }

        // 创建视频元素来获取视频时长
        const video = document.createElement('video')
        video.preload = 'metadata'

        return new Promise((resolve) => {
          video.onloadedmetadata = () => {
            window.URL.revokeObjectURL(video.src)
            const duration = video.duration

            // 保存视频时长到文件对象中
            file.duration = parseFloat(duration.toFixed(2))

            if (duration > 30) {
              this.$message.error('视频时长不能超过30秒')
              resolve(false)
            } else {
              resolve(true)
            }
          }

          video.src = URL.createObjectURL(file)
        })
      },
      /**
       * 文件上传方法
       * @param file 文件对象
       * @returns {Promise<void>}
       */
      async handleUpload(file) {
        if (!file) return

        try {
          this.spinning = true
          this.uploading = true

          // 获取视频第一帧作为封面图
          const coverImage = await this.getVideoFirstFrame(file)

          // 上传视频文件
          const result = await putObject(file)

          // 上传封面图片
          let coverResult = null
          if (coverImage) {
            coverResult = await putObject(coverImage)
            if (coverResult && coverResult.name) {
              this.videoCoverUrl = coverResult.name
            }
          }

          this.spinning = false
          this.uploading = false
          if (result && result.url) {
            // 设置显示URL
            this.displayUrl = result.url
            // 兼容原有的cb回调
            this.$emit('cb', {
              ...result,
              videoCoverUrl: this.videoCoverUrl,
            })

            this.$message.success('上传成功')
          }

          this.$refs.fileDom.value = ''
        } catch (e) {
          this.spinning = false
          this.uploading = false
          console.error('上传失败:', e)

          let errorMsg = '上传失败'
          if (e.name === 'ConnectionTimeoutError') {
            errorMsg = '上传超时，请检查网络连接或稍后再试'
          } else if (e.status >= 400) {
            errorMsg = `上传失败: ${e.message || '服务器错误'}`
          }

          this.$message.error(errorMsg)
          this.$refs.fileDom.value = ''
        }
      },
      /**
       * 获取视频第一帧作为封面图
       * @param {File} videoFile 视频文件
       * @returns {Promise<File|null>} 返回封面图文件
       */
      getVideoFirstFrame(videoFile) {
        return new Promise((resolve) => {
          const video = document.createElement('video')
          video.preload = 'auto'
          video.muted = true
          video.playsInline = true
          video.crossOrigin = 'anonymous'

          // 监听可以播放事件
          video.addEventListener('loadedmetadata', () => {
            // 设置到稍后一点的时间点，避免黑屏
            video.currentTime = 1.0 // 设置为第1秒，避免黑屏
          })

          // 当视频跳转到指定时间后触发
          video.addEventListener('seeked', () => {
            // 创建canvas用于绘制视频帧
            const canvas = document.createElement('canvas')
            canvas.width = video.videoWidth
            canvas.height = video.videoHeight

            // 在canvas上绘制当前视频帧
            const ctx = canvas.getContext('2d')
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height)

            // 将canvas转换为Blob
            canvas.toBlob(
              (blob) => {
                if (blob) {
                  // 创建File对象
                  const coverFile = new File([blob], `${videoFile.name.split('.')[0]}_cover.jpg`, {
                    type: 'image/jpeg',
                    lastModified: Date.now(),
                  })
                  resolve(coverFile)
                } else {
                  resolve(null)
                }

                // 清理资源
                window.URL.revokeObjectURL(video.src)
              },
              'image/jpeg',
              0.9
            )
          })

          // 处理错误
          video.onerror = () => {
            console.error('获取视频首帧失败')
            window.URL.revokeObjectURL(video.src)
            resolve(null)
          }

          // 设置视频源
          video.src = URL.createObjectURL(videoFile)
        })
      },
      /**
       * 删除
       **/
      handleRemove() {
        // 清空显示URL
        this.displayUrl = ''

        // 返回正确的结果
        this.$emit('update:url', '')
        this.$emit('cb', '')
        this.$emit('cbFile', {})

        this.$message.success('已删除')
      },
    },
  }
</script>
<style lang="scss" scoped>
  .mpm_upload_img {
    line-height: 1.5;

    .table-cell_upload,
    .table-cell_upload_1 {
      display: table-cell;
      width: 100%;
      height: 100%;
      padding: 0;
      text-align: center;
      vertical-align: middle;
    }

    .upload-placeholder {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .ant-upload-hint {
        font-size: 12px;
        color: #999;
        margin-top: 4px;
      }
    }

    .upload-list-item-actions {
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 10;
      white-space: nowrap;
      transform: translate(-50%, -50%);
      opacity: 0;
      transition: all 0.3s;

      .action-icon {
        font-size: 24px;
        margin: 0 8px;
        color: white;
        background: rgba(0, 0, 0, 0.5);
        padding: 8px;
        border-radius: 50%;
        transition: all 0.3s;

        &:hover {
          transform: scale(1.1);
          color: #7468f2;
          background: rgba(255, 255, 255, 0.8);
        }
      }
    }

    .video_block {
      position: relative;
      width: 104px;
      height: 104px;
      padding: 6px;
      display: flex;
      align-items: center;
      justify-content: center;

      .video-preview {
        object-fit: cover;
        border-radius: 4px;
      }
    }

    .table-cell_upload:hover {
      .video_block::before {
        position: absolute;
        z-index: 1;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        transition: all 0.3s;
        content: ' ';
        border-radius: 4px;
      }

      .upload-list-item-actions {
        opacity: 1;
      }
    }

    .upload_card {
      display: table;
      width: 104px;
      height: 104px;
      margin-right: 8px;
      margin-bottom: 8px;
      text-align: center;
      vertical-align: top;
      background-color: #fafafa;
      border: 1px dashed #d9d9d9;
      border-radius: 4px;
      cursor: pointer;
      transition: all 0.3s ease;
      overflow: hidden;
      position: relative;

      &:hover {
        border-color: #7468f2;

        .anticon {
          color: #7468f2;
        }
      }

      &.upload-card-hover {
        border-color: #d9d9d9;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
      }
    }

    .anticon {
      font-size: 28px;
      color: #999;
      display: inline-block;
      font-style: normal;
      line-height: 0;
      text-align: center;
      text-transform: none;
      vertical-align: -0.125em;
      text-rendering: optimizeLegibility;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      transition: color 0.3s;
    }
  }

  .modal_video {
    padding: 20px 0;
    text-align: center;

    .video-player {
      width: 100%;
      max-height: 50vh;
      object-fit: contain;
      border-radius: 4px;
    }

    .video-info {
      text-align: left;
      margin-top: 12px;
      padding: 12px;
      background-color: #f9f9f9;
      border-radius: 4px;

      p {
        margin-bottom: 4px;
        font-size: 14px;
        color: #666;
      }
    }
  }
</style>
